import {
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowRightLeft,
  ArrowUp,
  Award,
  BadgeCheck,
  BarChart3,
  Barcode,
  Bath,
  BellRing,
  BookOpen,
  Box,
  Boxes,
  BrainCircuit,
  Briefcase,
  Building,
  Building2,
  CalendarClock,
  CalendarDays,
  CalendarRange,
  Calculator,
  CheckSquare,
  CircleCheck,
  CircleUser,
  ClipboardCheck,
  ClipboardList,
  Clock,
  Cog,
  ConciergeBell,
  Contact,
  Currency,
  Database,
  Delete,
  DoorOpen,
  Droplet,
  Droplets,
  Euro,
  Factory,
  FileBadge,
  FileCheck,
  FileSignature,
  FileSpreadsheet,
  FileText,
  Flame,
  FlaskConical,
  Form,
  Fuel,
  Gauge,
  GraduationCap,
  Group,
  Handshake,
  Heading1,
  Heading2,
  Heading3,
  HeartPulse,
  Hourglass,
  IdCard,
  Inbox,
  Info,
  Kanban,
  Landmark,
  Layers,
  LayoutDashboard,
  Leaf,
  Library,
  ListChecks,
  LogIn,
  Mail,
  MailCheck,
  MailSearch,
  Map,
  Megaphone,
  Package,
  PackageCheck,
  PackageOpen,
  PackageSearch,
  Palette,
  PhoneCall,
  Plus,
  Printer,
  Puzzle,
  Quote,
  Recycle,
  Reply,
  Rss,
  Ruler,
  Scale,
  ScanLine,
  ScanText,
  Settings,
  Settings2,
  Sheet,
  Shield,
  ShieldAlert,
  ShieldCheck,
  Shirt,
  ShoppingCart,
  Stethoscope,
  Table,
  TableProperties,
  Target,
  Terminal,
  TrendingUp,
  Truck,
  User,
  UserCheck,
  UserCircle,
  Users,
  Users2,
  Video,
  Voicemail,
  Volume,
  Wallet,
  Warehouse,
  Weight,
  Workflow,
  Wrench,
  Zap,
  type LucideIcon,
} from "lucide-react";

/**
 * Ícones que o servidor e a configuração referem por NOME (catálogo de permissões, menu, pesquisa global).
 *
 * `import * as Icons from "lucide-react"` e `Icons[nome]` obrigam o bundler a embarcar a biblioteca inteira
 * (~850 KB no bundle de entrada). Este registo lista só o que é realmente referido; o teste
 * `icons.test.ts` falha se aparecer um nome novo no código e faltar aqui.
 */
const ICONS: Record<string, LucideIcon> = {
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowRightLeft,
  ArrowUp,
  Award,
  BadgeCheck,
  BarChart3,
  Barcode,
  Bath,
  BellRing,
  BookOpen,
  Box,
  Boxes,
  BrainCircuit,
  Briefcase,
  Building,
  Building2,
  CalendarClock,
  CalendarDays,
  CalendarRange,
  Calculator,
  CheckSquare,
  CircleCheck,
  CircleUser,
  ClipboardCheck,
  ClipboardList,
  Clock,
  Cog,
  ConciergeBell,
  Contact,
  Currency,
  Database,
  Delete,
  DoorOpen,
  Droplet,
  Droplets,
  Euro,
  Factory,
  FileBadge,
  FileCheck,
  FileSignature,
  FileSpreadsheet,
  FileText,
  Flame,
  FlaskConical,
  Form,
  Fuel,
  Gauge,
  GraduationCap,
  Group,
  Handshake,
  Heading1,
  Heading2,
  Heading3,
  HeartPulse,
  Hourglass,
  IdCard,
  Inbox,
  Info,
  Kanban,
  Landmark,
  Layers,
  LayoutDashboard,
  Leaf,
  Library,
  ListChecks,
  LogIn,
  Mail,
  MailCheck,
  MailSearch,
  Map,
  Megaphone,
  Package,
  PackageCheck,
  PackageOpen,
  PackageSearch,
  Palette,
  PhoneCall,
  Plus,
  Printer,
  Puzzle,
  Quote,
  Recycle,
  Reply,
  Rss,
  Ruler,
  Scale,
  ScanLine,
  ScanText,
  Settings,
  Settings2,
  Sheet,
  Shield,
  ShieldAlert,
  ShieldCheck,
  Shirt,
  ShoppingCart,
  Stethoscope,
  Table,
  TableProperties,
  Target,
  Terminal,
  TrendingUp,
  Truck,
  User,
  UserCheck,
  UserCircle,
  Users,
  Users2,
  Video,
  Voicemail,
  Volume,
  Wallet,
  Warehouse,
  Weight,
  Workflow,
  Wrench,
  Zap,
};

/** O ícone com este nome, ou `null` se não existir no registo. */
export function iconByName(name: string | null | undefined): LucideIcon | null {
  return name ? (ICONS[name] ?? null) : null;
}

/** Nomes registados, para o teste de cobertura. */
export const REGISTERED_ICON_NAMES: readonly string[] = Object.keys(ICONS);
